module.exports = __webpack_public_path__ + "img/k.b116a46a.jpg";